import { useState, useEffect, useCallback } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Tooltip,
  Divider,
  Typography,
  MenuItem,
} from "@mui/material";
import { Visibility as ViewIcon } from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { DataGrid, Toolbar, ToolbarButton } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";
import ConfirmDialog from "../components/ConfirmDialog";

import customerApi from "../api/customerApi";
import orderApi from "../api/orderApi";

const businessTypes = ["Công ty", "Hộ kinh doanh", "Cá nhân kinh doanh"];
const calculationMethod = [
  { value: 1, label: "Trực tiếp" },
  { value: 2, label: "Khấu trừ" },
];
function isValidEmail(email) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
}
const pageNo = "CustomersPage";
function CustomersPage() {
  const user = useSelector((state) => state.auth.user);
  const roles = useSelector((state) => state.auth.roles) || null;

  // Tìm kiếm
  const [searchParams, setSearchParams] = useState({
    searchKeyword: "",
  });
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);

  // Phân trang
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [totalRowCount, setTotalRowCount] = useState(0);

  // Form thêm, sửa khách hàng
  const [openAddEditModal, setOpenAddEditModal] = useState(false);
  const [currentCustomerToEdit, setCurrentCustomerToEdit] = useState(null);

  const [formErrors, setFormErrors] = useState({}); // state này để hiển thị lỗi validation trên form
  const [openCustomerOrdersModal, setOpenCustomerOrdersModal] = useState(false);
  const [orders, setOrders] = useState([]);
  const [orderPaginationModel, setOrderPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [orderTotalRowCount, setOrderTotalRowCount] = useState(0);

  const [openModalOrder, setOpenModalOrder] = useState(false);
  const [orderId, setOrderId] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [unitPrice, setUnitPrice] = useState(3000000);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [totalPrice, setTotalPrice] = useState(0);
  const [note, setNote] = useState("");
  const [isPaid, setIsPaid] = useState(false);
  const [customer, setCustomer] = useState(null);
  const [openOrderInforModal, setOpenOrderInforModal] = useState(false);
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [qrLink, setQrLink] = useState("");

  // const getFilteredMethods = () => {
  //   if (currentCustomerToEdit?.CusBusinessType === "Công ty") {
  //     return calculationMethod.filter((method) => method.value === 2); // Chỉ lấy khấu trừ
  //   }
  //   if (
  //     currentCustomerToEdit?.CusBusinessType === "Hộ kinh doanh" ||
  //     currentCustomerToEdit?.CusBusinessType === "Cá nhân kinh doanh"
  //   ) {
  //     return calculationMethod.filter((method) => method.value === 1); // Chỉ lấy trực tiếp
  //   }
  //   return []; // Cá nhân hoặc chưa chọn thì trả về mảng rỗng
  // };

  // const filteredMethods = getFilteredMethods();

  /*Dialog confirm*/
  const [confirmDialogState, setConfirmDialogState] = useState({
    open: false,
    title: "",
    content: "",
    onConfirm: () => {},
    onClose: () => {},
  });

  // --- LOGIC TÌM KIẾM DỮ LIỆU ---

  const fetchCustomers = useCallback(async (searchKeyword, page, pageSize) => {
    setLoading(true);
    try {
      const response = await customerApi.searchCustomers(
        searchKeyword,
        page,
        pageSize,
      );

      if (response.success) {
        setCustomers(response.data.customers);
        setTotalRowCount(response.pagination.totalRecords || 0);
      } else {
        toast.error("Lỗi khi tìm kiếm dữ liệu khách hàng");
        setCustomers([]);
        setTotalRowCount(0);
      }
    } catch (error) {
      console.error("Lỗi khi tìm kiếm khách hàng:", error);
      toast.error(error.message);
      setCustomers([]);
      setTotalRowCount(0);
    } finally {
      setLoading(false);
    }
  }, []);

  const handlePaginationModelChange = (newModel) => {
    setPaginationModel(newModel);
    fetchCustomers(
      searchParams.searchKeyword,
      newModel.page,
      newModel.pageSize,
    );
  };
  const handleOrderPaginationModelChange = useCallback((newModel) => {
    setOrderPaginationModel(newModel);
  }, []);

  const handleSearch = () => {
    fetchCustomers(
      searchParams.searchKeyword,
      paginationModel.page,
      paginationModel.pageSize,
    );
  };
  useEffect(() => {
    fetchCustomers(
      searchParams.searchKeyword,
      paginationModel.page,
      paginationModel.pageSize,
    );
  }, []);

  const handleAddCustomer = () => {
    if (
      !roles.some(
        (x) =>
          x.PvNo === pageNo && x.CtrNo === "btnAdd" && x.IsApproved === true,
      )
    ) {
      toast.warning("Bạn không có quyền thêm khách hàng.");
      return;
    }
    setCurrentCustomerToEdit({
      CusId: null,
      CusCompanyName: "",
      CusTaxId: "",
      CusAddress: "",
      CusRepresentativeName: "",
      CusPhoneNumber: "",
      CusEmail: "",
      CusWebsite: "",
      CusBusinessType: "",
      CusCompanyEstablishmentDate: dayjs(),
      CusPosition: "",
      CusEmailReceiveInvoice: "",
      CusTaxCalculationMethod: 1,
    });
    setFormErrors({}); // Xóa lỗi cũ
    setOpenAddEditModal(true);
  };

  const handleEditCustomer = async (customerId) => {
    if (
      !roles.some(
        (x) =>
          x.PvNo === pageNo && x.CtrNo === "btnEdit" && x.IsApproved === true,
      )
    ) {
      toast.warning("Bạn không có quyền sửa khách hàng.");
      return;
    }
    try {
      const response = await customerApi.getCustomerInfor(customerId);
      if (response.success) {
        setCurrentCustomerToEdit(response.data);
        setFormErrors({}); // Xóa lỗi cũ
        setOpenAddEditModal(true);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleCloseAddEditModal = () => {
    setOpenAddEditModal(false);
    setCurrentCustomerToEdit(null);
    setFormErrors({});
    handleSearch();
  };

  const handleSaveCustomer = async () => {
    setLoading(true);

    const errors = {};
    // Validate các trường bắt buộc
    if (!currentCustomerToEdit.CusTaxId) {
      errors.cusTaxId = "Mã số thuế không được để trống.";
    }
    if (!currentCustomerToEdit.CusCompanyName) {
      errors.cusCompanyName = "Tên đơn vị không được để trống.";
    }
    if (!currentCustomerToEdit.CusBusinessType) {
      errors.cusBusinessType = "Loại hình doanh nghiệp không được để trống.";
    }
    if (!currentCustomerToEdit.CusEmail) {
      errors.cusEmail = "Email không được để trống.";
    } else if (!isValidEmail(currentCustomerToEdit.CusEmail))
      errors.cusEmail = "Email không hợp lệ";
    if (!currentCustomerToEdit.CusRepresentativeName) {
      errors.cusRepresentativeName = "Người đại diện không được để trống.";
    }
    if (
      currentCustomerToEdit.CusEmailReceiveInvoice &&
      !isValidEmail(currentCustomerToEdit.CusEmailReceiveInvoice)
    )
      errors.cusEmailReceiveInvoice = "Email không hợp lệ";
    // if (
    //   !filteredMethods.find(
    //     (method) =>
    //       method.value === currentCustomerToEdit.CusTaxCalculationMethod,
    //   )
    // ) {
    //   currentCustomerToEdit.CusTaxCalculationMethod = null;
    // }
    // if (currentCustomerToEdit.CusTaxCalculationMethod == null)
    //   errors.cusTaxCalculationMethod =
    //     "Phương pháp tính thuế không được để trống.";
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      toast.error("Vui lòng điền đầy đủ các trường bắt buộc.", "error");
      setLoading(false);
      return;
    }

    try {
      const response = await customerApi.upsertCustomer(currentCustomerToEdit);
      if (response.success) {
        toast.success("Lưu khách hàng thành công!");
        handleCloseAddEditModal();
        setPaginationModel((prev) => ({ ...prev, page: 0 }));
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Lỗi khi lưu khách hàng:", error);
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (customerId) => {
    if (
      !roles.some(
        (x) =>
          x.PvNo === pageNo && x.CtrNo === "btnDelete" && x.IsApproved === true,
      )
    ) {
      toast.warning("Bạn không có quyền xoá khách hàng.");
      return;
    }
    try {
      setConfirmDialogState({
        open: true,
        title: "Xoá khách hàng",
        content: "Bạn có chắc chắn muốn xóa khách hàng này không?",
        onConfirm: async () => {
          const response = await customerApi.deleteCustomer(customerId);
          if (response.success) {
            toast.success("Xóa khách hàng thành công!");
            setConfirmDialogState({
              ...confirmDialogState,
              open: false,
            });
            handleSearch();
          } else {
            toast.error(response.message);
          }
        },
        onClose: () =>
          setConfirmDialogState({
            ...confirmDialogState,
            open: false,
          }),
      });
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleOpenCustomerOrdersModal = async (customerId) => {
    try {
      const response = await orderApi.SearchCustomerOrders(
        customerId,
        orderPaginationModel.page,
        orderPaginationModel.pageSize,
      );
      if (response.success) {
        let cus = customers.find((c) => c.CusId === customerId);
        setCustomer(cus);
        setOrders(response.data);
        setOrderTotalRowCount(response.pagination.totalRecords || 0);
        setOpenCustomerOrdersModal(true);
      } else {
        toast.error("Lỗi dữ liệu server");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleCloseCustomerOrdersModal = () => {
    setOpenCustomerOrdersModal(false);
    setCustomer(null);
  };

  const handleAddOrder = async () => {
    try {
      let customerData = null;
      const reCustomer = await customerApi.getCustomerInfor(customer.CusId);
      if (reCustomer.success) {
        customerData = reCustomer.data;
      }
      const response = await orderApi.getLastOrder(customer.CusId);
      if (response.success) {
        if (response.data?.is_paid === false) {
          toast.warning(
            "Vui lòng thanh toán đơn hàng cũ trước khi tạo đơn hàng mới",
          );
          return;
        }
        setOrderId(null);
        setStartDate(dayjs(customerData?.CusExpiredDate));
        setEndDate(dayjs(customerData?.CusExpiredDate).add(1, "year"));
        setQuantity(1);
        setTotalPrice(unitPrice);
        setNote("");
      } else {
        setOrderId(null);
        setStartDate(dayjs(customerData?.CusExpiredDate));
        setQuantity(1);
        setNote("");
      }
    } catch (error) {
      toast.error(error.message);
    }
    setOpenModalOrder(true);
  };
  const handleEditOrder = async (orderId) => {
    try {
      const response = await orderApi.getOrderInfor(orderId);
      if (response.success) {
        setOrderId(response.data.order_id);
        setQuantity(response.data.quantity);
        setTotalPrice(response.data.total_amount);
        setNote(response.data.note);
        setStartDate(dayjs(response.data.start_time));
        setEndDate(dayjs(response.data.end_time));
        setIsPaid(response.data.is_paid);
        setQrLink(response.data.qr_link);
        setOpenOrderInforModal(true);
      } else {
        toast.error("Lỗi lấy thông tin đơn hàng. Vui lòng thử lại sau.");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handlePaymentApproval = async () => {
    try {
      const check = await orderApi.checkPaymentStatus(orderId);
      if (check.success) {
        toast.success("Đơn hàng đã nhận được thanh toán");
        await handleEditOrder(orderId);
      } else {
        setConfirmDialogState({
          open: true,
          title: "Ghi nhận thanh toán cho đơn hàng",
          content:
            "Đơn hàng chưa nhận được thanh toán. Bạn có muốn tiếp tục ghi nhận thanh toán cho đơn hàng này không?",
          onConfirm: async () => {
            const response = await orderApi.handlePaymentApproval(
              orderId,
              user.UsId,
            );
            if (response.success) {
              toast.success("Duyệt thanh toán thành công");
              setConfirmDialogState({
                ...confirmDialogState,
                open: false,
              });
              handleCloseOrderInforModal();
            } else {
              toast.error(response.message);
            }
          },
          onClose: () =>
            setConfirmDialogState({
              ...confirmDialogState,
              open: false,
            }),
        });
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleCheckPaymentStatus = async () => {
    try {
      const check = await orderApi.checkPaymentStatus(orderId);
      if (check.success) {
        toast.success("Đơn hàng đã nhận được thanh toán");
        await handleEditOrder(orderId);
      } else {
        toast.warning("Đơn hàng chưa nhận được thanh toán.");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleCreateOrder = async () => {
    try {
      const response = await orderApi.createOrder(
        orderId,
        quantity,
        unitPrice,
        totalPrice,
        note,
        startDate,
        endDate,
        customer.CusId,
        user.UsId,
      );
      if (response.success) {
        toast.success("Tạo đơn hàng thành công");
        handleClodeOrderModal();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleClodeOrderModal = () => {
    setOpenModalOrder(false);
    setOrderId(null);
    setQuantity(1);
    setTotalPrice(unitPrice);
    setNote("");
    handleOpenCustomerOrdersModal(customer.CusId);
  };
  const handleQuantityChange = (e) => {
    const value = parseInt(e.target.value) || 0;
    setQuantity(value);
    setTotalPrice(value * unitPrice);
    setEndDate(startDate.add(value, "year"));
  };

  const handleCheckPayment = () => {
    setOpenPaymentModal(true);
  };
  const handleClosePaymentModal = () => {
    setOpenPaymentModal(false);
  };
  const handleCloseOrderInforModal = () => {
    handleOpenCustomerOrdersModal(customer.CusId);
    setOpenOrderInforModal(false);
  };

  const columns = [
    {
      field: "CusNo",
      headerName: "Mã khách hàng",
      headerAlign: "center",
      width: 300,
    },
    {
      field: "CusCompanyName",
      headerName: "Tên công ty",
      headerAlign: "center",
      width: 300,
    },
    {
      field: "CusTaxId",
      headerName: "MST",
      headerAlign: "center",
      width: 105,
    },
    {
      field: "CusAddress",
      headerName: "Địa chỉ",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "CusRepresentativeName",
      headerName: "Người đại diện",
      headerAlign: "center",
      width: 170,
    },
    {
      field: "CusEmail",
      headerName: "Email liên hệ",
      headerAlign: "center",
      width: 200,
    },
    {
      field: "CusPhoneNumber",
      headerName: "SĐT",
      headerAlign: "center",
      align: "center",
      width: 110,
    },
    {
      field: "CusBusinessType",
      headerName: "Loại hình doanh nghiệp",
      headerAlign: "center",
      width: 170,
    },
    {
      field: "CusInvoiceQuantityRemain",
      headerName: "HĐ còn lại",
      headerAlign: "center",
      align: "right",
      width: 85,
    },
    {
      field: "CusExpiredDate",
      headerName: "Hạn sử dụng",
      headerAlign: "center",
      width: 100,
      renderCell: (params) => {
        return params.value ? dayjs(params.value).format("DD/MM/YYYY") : "";
      },
    },
    {
      field: "actions",
      headerName: "Chức năng",
      headerAlign: "center",
      type: "actions",
      width: 90,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Box>
          <Tooltip title="Sửa">
            <IconButton
              color="primary"
              size="small"
              onClick={() => handleEditCustomer(params.row.CusId)}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Xoá">
            <IconButton
              color="error"
              size="small"
              onClick={() => handleDelete(params.row.CusId)}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          {/* <Button
            color="primary"
            size="small"
            variant="outlined"
            onClick={() => handleOpenCustomerOrdersModal(params.row.CusId)}
          >
            Đơn hàng
          </Button> */}
        </Box>
      ),
    },
  ];

  const CustomToolbar = () => {
    return (
      <Toolbar>
        <Tooltip title="Tạo đơn hàng mới">
          <ToolbarButton>
            <AddIcon onClick={() => handleAddOrder()} />
          </ToolbarButton>
        </Tooltip>
      </Toolbar>
    );
  };

  const orderColumns = [
    {
      field: "order_code",
      headerName: "Mã đơn hàng",
      headerAlign: "center",
      width: 300,
    },
    {
      field: "created_at",
      headerName: "Ngày tạo",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: (params) => {
        return params.value ? dayjs(params.value).format("DD/MM/YYYY") : "";
      },
    },
    {
      field: "quantity",
      headerName: "SL mua",
      headerAlign: "center",
      align: "right",
      width: 80,
    },
    {
      field: "start_time",
      headerName: "Tg bắt đầu",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return params.value ? dayjs(params.value).format("DD/MM/YYYY") : "";
      },
    },
    {
      field: "end_time",
      headerName: "Tg kết thúc",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return params.value ? dayjs(params.value).format("DD/MM/YYYY") : "";
      },
    },
    {
      field: "UsFullName",
      headerName: "Người tạo",
      headerAlign: "center",
      width: 150,
    },
    {
      field: "note",
      headerName: "Ghi chú",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "is_paid",
      headerName: "Thanh toán",
      headerAlign: "center",
      type: "boolean",
      width: 110,
    },
    {
      field: "actions",
      headerName: "Chức năng",
      headerAlign: "center",
      type: "actions",
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Box>
          <Tooltip title="Xem">
            <IconButton
              color="primary"
              size="small"
              onClick={() => handleEditOrder(params.row.order_id)}
            >
              <ViewIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
      <Box sx={{ p: 2, flexGrow: 1, display: "flex", flexDirection: "column" }}>
        <Paper elevation={3} sx={{ p: 2, mb: 3 }}>
          <Grid
            container
            spacing={1}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Grid
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <TextField
                size="small"
                label="Từ khoá"
                variant="outlined"
                value={searchParams.searchKeyword}
                onChange={(e) =>
                  setSearchParams({
                    ...searchParams,
                    searchKeyword: e.target.value,
                  })
                }
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleSearch();
                  }
                }}
                sx={{ mr: 1, minWidth: 400 }}
              />
              <Button
                variant="contained"
                startIcon={<SearchIcon />}
                onClick={handleSearch}
                disabled={loading}
                size="medium"
              >
                Tìm kiếm
              </Button>
            </Grid>
            <Grid>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleAddCustomer}
                size="medium"
              >
                Thêm khách hàng mới
              </Button>
            </Grid>
          </Grid>
        </Paper>
        {/* DataGrid danh sách khách hàng */}
        <Box sx={{ flexGrow: 1, width: "100%" }}>
          <DataGrid
            rows={customers}
            columns={columns}
            paginationMode="server"
            rowCount={totalRowCount}
            paginationModel={paginationModel}
            onPaginationModelChange={handlePaginationModelChange}
            pageSizeOptions={[10, 20, 50, 100]}
            disableRowSelectionOnClick
            loading={loading}
            getRowId={(row) => row.CusId}
            showCellVerticalBorder
            showColumnVerticalBorder
          />
        </Box>

        {/* Modal Thêm/Sửa khách hàng */}
        <Dialog
          open={openAddEditModal}
          onClose={handleCloseAddEditModal}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            {currentCustomerToEdit?.CusId
              ? "Sửa thông tin"
              : "Thêm khách hàng mới"}
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={0.75} sx={{ mt: 1 }}>
              <Grid size={4}>
                <TextField
                  label="Mã số thuế"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={currentCustomerToEdit?.CusTaxId}
                  error={!!formErrors.cusTaxId}
                  helperText={formErrors.cusTaxId}
                  onChange={(e) => {
                    setCurrentCustomerToEdit((prev) => ({
                      ...prev,
                      CusTaxId: e.target.value,
                    }));
                    setFormErrors((prev) => ({ ...prev, cusTaxId: "" }));
                  }}
                  size="small"
                  required
                />
              </Grid>
              <Grid size={8}>
                <TextField
                  autoFocus
                  label="Tên đơn vị"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={currentCustomerToEdit?.CusCompanyName}
                  error={!!formErrors.cusCompanyName}
                  helperText={formErrors.cusCompanyName}
                  onChange={(e) => {
                    setCurrentCustomerToEdit((prev) => ({
                      ...prev,
                      CusCompanyName: e.target.value,
                    }));
                    setFormErrors((prev) => ({ ...prev, cusCompanyName: "" }));
                  }}
                  size="small"
                  required
                />
              </Grid>

              <Grid size={12}>
                <TextField
                  label="Địa chỉ đơn vị"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={currentCustomerToEdit?.CusAddress}
                  error={!!formErrors.cusAddress}
                  helperText={formErrors.cusAddress}
                  onChange={(e) => {
                    setCurrentCustomerToEdit((prev) => ({
                      ...prev,
                      CusAddress: e.target.value,
                    }));
                    setFormErrors((prev) => ({ ...prev, cusAddress: "" }));
                  }}
                  size="small"
                />
              </Grid>
              <Grid size={6}>
                <TextField
                  select
                  label="Loại hình doanh nghiệp"
                  fullWidth
                  value={currentCustomerToEdit?.CusBusinessType}
                  onChange={(e) =>
                    setCurrentCustomerToEdit((prev) => ({
                      ...prev,
                      CusBusinessType: e.target.value,
                    }))
                  }
                  size="small"
                >
                  {businessTypes.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid size={6}>
                <DatePicker
                  label="Ngày thành lập"
                  format="DD/MM/YYYY"
                  value={
                    currentCustomerToEdit?.CusCompanyEstablishmentDate
                      ? dayjs(currentCustomerToEdit.CusCompanyEstablishmentDate)
                      : dayjs()
                  }
                  onChange={(newValue) =>
                    setCurrentCustomerToEdit((prev) => ({
                      ...prev,
                      CusCompanyEstablishmentDate: newValue,
                    }))
                  }
                  renderInput={(params) => <TextField {...params} fullWidth />}
                  slotProps={{
                    textField: {
                      size: "small",
                      fullWidth: true,
                    },
                  }}
                />
              </Grid>
              <Grid size={6}>
                <TextField
                  id="representative"
                  label="Người đại diện"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={currentCustomerToEdit?.CusRepresentativeName}
                  onChange={(e) => {
                    setCurrentCustomerToEdit((prev) => ({
                      ...prev,
                      CusRepresentativeName: e.target.value,
                    }));
                    setFormErrors((prev) => ({
                      ...prev,
                      cusRepresentativeName: "",
                    }));
                  }}
                  error={!!formErrors.cusRepresentativeName}
                  helperText={formErrors.cusRepresentativeName}
                  size="small"
                  required
                />
              </Grid>
              <Grid size={6}>
                <TextField
                  label="Chức vụ"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={currentCustomerToEdit?.CusPosition}
                  onChange={(e) => {
                    setCurrentCustomerToEdit((prev) => ({
                      ...prev,
                      CusPosition: e.target.value,
                    }));
                    setFormErrors((prev) => ({
                      ...prev,
                      cusPosition: "",
                    }));
                  }}
                  error={!!formErrors.cusPosition}
                  helperText={formErrors.cusPosition}
                  size="small"
                />
              </Grid>
              <Grid size={6}>
                <TextField
                  label="Email liên hệ"
                  type="email"
                  fullWidth
                  variant="outlined"
                  value={currentCustomerToEdit?.CusEmail}
                  error={!!formErrors.cusEmail}
                  helperText={formErrors.cusEmail}
                  onChange={(e) => {
                    setCurrentCustomerToEdit((prev) => ({
                      ...prev,
                      CusEmail: e.target.value,
                    }));
                    setFormErrors((prev) => ({ ...prev, cusEmail: "" }));
                  }}
                  size="small"
                  required
                />
              </Grid>
              <Grid size={6}>
                <TextField
                  label="Email nhận hóa đơn"
                  type="email"
                  fullWidth
                  variant="outlined"
                  value={currentCustomerToEdit?.CusEmailReceiveInvoice}
                  error={!!formErrors.cusEmailReceiveInvoice}
                  helperText={formErrors.cusEmailReceiveInvoice}
                  onChange={(e) => {
                    setCurrentCustomerToEdit((prev) => ({
                      ...prev,
                      CusEmailReceiveInvoice: e.target.value,
                    }));
                    setFormErrors((prev) => ({
                      ...prev,
                      cusEmailReceiveInvoice: "",
                    }));
                  }}
                  size="small"
                />
              </Grid>
              <Grid size={6}>
                <TextField
                  label="Điện thoại liên hệ"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={currentCustomerToEdit?.CusPhoneNumber}
                  error={!!formErrors.cusPhoneNumber}
                  helperText={formErrors.cusPhoneNumber}
                  onChange={(e) => {
                    setCurrentCustomerToEdit((prev) => ({
                      ...prev,
                      CusPhoneNumber: e.target.value,
                    }));
                    setFormErrors((prev) => ({ ...prev, cusPhoneNumber: "" }));
                  }}
                  size="small"
                />
              </Grid>
              <Grid size={6}>
                <TextField
                  label="Website"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={currentCustomerToEdit?.CusWebsite}
                  error={!!formErrors.cusWebsite}
                  helperText={formErrors.cusWebsite}
                  onChange={(e) => {
                    setCurrentCustomerToEdit((prev) => ({
                      ...prev,
                      CusWebsite: e.target.value,
                    }));

                    setFormErrors((prev) => ({ ...prev, cusWebsite: "" }));
                  }}
                  size="small"
                />
              </Grid>
              {/* <Grid size={6}>
                <TextField
                  select
                  label="Phương pháp tính thuế"
                  fullWidth
                  value={currentCustomerToEdit?.CusTaxCalculationMethod}
                  error={!!formErrors.cusTaxCalculationMethod}
                  helperText={formErrors.cusTaxCalculationMethod}
                  onChange={(e) =>
                    setCurrentCustomerToEdit((prev) => ({
                      ...prev,
                      CusTaxCalculationMethod: e.target.value,
                    }))
                  }
                  size="small"
                  required
                >
                  {filteredMethods.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid> */}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseAddEditModal} color="primary">
              Hủy
            </Button>
            <Button
              onClick={handleSaveCustomer}
              variant="contained"
              color="primary"
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : "Lưu"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openCustomerOrdersModal} maxWidth="lg" fullWidth>
          <DialogTitle>Đơn hàng gia hạn sử dụng</DialogTitle>
          <Divider />
          <DialogContent>
            <DataGrid
              rows={orders}
              columns={orderColumns}
              getRowId={(row) => row.order_id}
              paginationMode="server"
              rowCount={orderTotalRowCount}
              paginationModel={orderPaginationModel}
              onPaginationModelChange={handleOrderPaginationModelChange}
              pageSizeOptions={[10, 20, 50, 100]}
              sx={{ maxHeight: "600px" }}
              showCellVerticalBorder
              showColumnVerticalBorder
              slots={{
                toolbar: CustomToolbar,
              }}
              showToolbar
            />
          </DialogContent>
          <DialogActions style={{ justifyContent: "flex-start" }}>
            <Button
              onClick={handleCloseCustomerOrdersModal}
              color="primary"
              variant="outlined"
            >
              Trở về
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openModalOrder} maxWidth="sm" fullWidth>
          <DialogTitle>Đơn hàng gia hạn sử dụng</DialogTitle>
          <DialogContent>
            <Box sx={{ mt: 1 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box display="flex" flexDirection="column" gap={2}>
                  <TextField
                    label="Đơn giá"
                    value={unitPrice.toLocaleString("vi-VN") + " VND/năm"}
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                  <TextField
                    label="Số lượng (năm)"
                    type="number"
                    value={quantity}
                    onChange={handleQuantityChange}
                    fullWidth
                    inputProps={{ min: 1 }}
                  />
                  <TextField
                    label="Tổng tiền"
                    value={totalPrice.toLocaleString("vi-VN") + " VND"}
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />

                  <DatePicker label="Ngày bắt đầu" value={startDate} readOnly />

                  <DatePicker label="Ngày kết thúc" value={endDate} readOnly />

                  <TextField
                    label="Ghi chú"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    fullWidth
                  />
                </Box>
              </LocalizationProvider>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenModalOrder(false)}>Hủy</Button>

            <Button variant="contained" onClick={handleCreateOrder}>
              Lưu
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openOrderInforModal} maxWidth="sm" fullWidth>
          <DialogTitle>Thông tin đơn hàng</DialogTitle>
          <DialogContent>
            <Box display="flex" flexDirection="column" gap={2}>
              <Typography>
                <strong>Đơn giá:</strong> {unitPrice?.toLocaleString("vi-VN")}{" "}
                VND/năm
              </Typography>
              <Typography>
                <strong>Số lượng mua:</strong> {quantity} năm
              </Typography>
              <Typography>
                <strong>Tổng tiền:</strong>{" "}
                {totalPrice?.toLocaleString("vi-VN")} VND
              </Typography>
              <Typography>
                <strong>Ngày bắt đầu:</strong> {startDate?.format("DD/MM/YYYY")}
              </Typography>
              <Typography>
                <strong>Ngày kết thúc:</strong> {endDate?.format("DD/MM/YYYY")}
              </Typography>
              <Typography>
                <strong>Thanh toán:</strong>{" "}
                {isPaid ? "Đã nhận thanh toán" : "Chưa nhận thanh toán"}
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenOrderInforModal(false)}>Đóng</Button>
            {isPaid === false && (
              <>
                <Button variant="contained" onClick={handleCheckPayment}>
                  QR thanh toán
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  onClick={handlePaymentApproval}
                >
                  Duyệt thanh toán
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    setOpenOrderInforModal(false);
                    setOpenModalOrder(true);
                  }}
                >
                  Sửa đơn
                </Button>
              </>
            )}
          </DialogActions>
        </Dialog>
        <Dialog open={openPaymentModal} maxWidth="sm" fullWidth>
          <DialogTitle>Thanh toán đơn hàng</DialogTitle>
          <DialogContent>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              gap={2}
            >
              <Box
                component="iframe"
                src={qrLink}
                title="QR Thanh toán"
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  width: "100%",
                  height: "650px",
                }}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                handleClosePaymentModal();
              }}
            >
              Đóng
            </Button>
            <Button variant="contained" onClick={handleCheckPaymentStatus}>
              Xác nhận
            </Button>
          </DialogActions>
        </Dialog>

        <ConfirmDialog
          open={confirmDialogState.open}
          title={confirmDialogState.title}
          content={confirmDialogState.content}
          onConfirm={confirmDialogState.onConfirm}
          onClose={confirmDialogState.onClose}
        />
      </Box>
    </LocalizationProvider>
  );
}

export default CustomersPage;
